import { useEffect, useState } from "react";
import { ShieldAlert, FileWarning, Timer } from "lucide-react";

// High-contrast restricted-access strip with NDA warning.
export function RestrictedBanner({ area = "ADMIN" }) {
  return (
    <div data-testid="restricted-banner" className="bg-red-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-center gap-3 flex-wrap">
        <ShieldAlert className="w-4 h-4 shrink-0" />
        <p className="font-mono text-[10px] sm:text-[11px] tracking-[0.25em] uppercase font-bold text-center">
          Restricted Access — {area} Personnel Only // All activity is monitored and recorded
        </p>
        <ShieldAlert className="w-4 h-4 shrink-0" />
      </div>
      <div className="bg-[#7f1d1d]">
        <p className="max-w-7xl mx-auto px-4 sm:px-6 py-1.5 font-mono text-[9px] tracking-[0.15em] uppercase text-red-100/90 text-center flex items-center justify-center gap-2">
          <FileWarning className="w-3 h-3 shrink-0" />
          Non-Disclosure Agreement in force — sharing any content, screenshots or discussion from this area is a breach of contract
        </p>
      </div>
    </div>
  );
}

// Live countdown to JWT expiry — auto-logs out at zero.
export function SessionCountdown() {
  const [left, setLeft] = useState(null);

  useEffect(() => {
    const getExp = () => {
      try {
        const token = localStorage.getItem("nc_token");
        if (!token) return null;
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.exp * 1000;
      } catch { return null; }
    };
    const exp = getExp();
    if (!exp) return undefined;
    const tick = () => {
      const remaining = exp - Date.now();
      if (remaining <= 0) {
        localStorage.removeItem("nc_token");
        localStorage.removeItem("nc_user");
        window.location.href = "/auth";
        return;
      }
      setLeft(remaining);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  if (left == null) return null;
  const totalSec = Math.floor(left / 1000);
  const d = Math.floor(totalSec / 86400);
  const h = Math.floor((totalSec % 86400) / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  const text = d > 0 ? `${d}d ${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}` : `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  const urgent = left < 15 * 60 * 1000;

  return (
    <div data-testid="session-countdown" className={`flex items-center gap-2 border px-2.5 py-1.5 font-mono text-[10px] tracking-[0.15em] ${urgent ? "border-red-500/50 text-red-400 bg-red-500/10" : "border-white/15 text-zinc-400"}`} title="Session expires — you will be logged out">
      <Timer className="w-3.5 h-3.5" />
      <span data-testid="session-countdown-text">{text}</span>
    </div>
  );
}
